"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
// @ts-check

/**
 * @param {V2.RefundDataGrouping} _policy_grouping
 * @returns {V2.RefundPolicyGroupInfo}
 */
function noRefunds(_policy_grouping) {
  // eslint-disable-line no-unused-vars
  return {
    icon: "ban",
    method: "!refund-and-exchange.content.refund.none.method",
    method_simplified: "!refund-and-exchange.content.refund.none.method.simplified"
  };
}

exports.default = noRefunds;
module.exports = exports.default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy92Mi9yZWZ1bmRzL25vLXJlZnVuZHMuanMiXSwibmFtZXMiOlsibm9SZWZ1bmRzIiwiX3BvbGljeV9ncm91cGluZyIsImljb24iLCJtZXRob2QiLCJtZXRob2Rfc2ltcGxpZmllZCJdLCJtYXBwaW5ncyI6Ijs7Ozs7QUFBQTs7QUFFQTs7OztBQUlBLFNBQVNBLFNBQVQsQ0FBbUJDLGdCQUFuQixFQUFxQztBQUNuQztBQUNBLFNBQU87QUFDTEMsVUFBTSxLQUREO0FBRUxDLFlBQVEsaURBRkg7QUFHTEMsdUJBQW1CO0FBSGQsR0FBUDtBQUtEOztrQkFFY0osUyIsImZpbGUiOiJuby1yZWZ1bmRzLmpzIiwic291cmNlc0NvbnRlbnQiOlsiLy8gQHRzLWNoZWNrXG5cbi8qKlxuICogQHBhcmFtIHtWMi5SZWZ1bmREYXRhR3JvdXBpbmd9IF9wb2xpY3lfZ3JvdXBpbmdcbiAqIEByZXR1cm5zIHtWMi5SZWZ1bmRQb2xpY3lHcm91cEluZm99XG4gKi9cbmZ1bmN0aW9uIG5vUmVmdW5kcyhfcG9saWN5X2dyb3VwaW5nKSB7XG4gIC8vIGVzbGludC1kaXNhYmxlLWxpbmUgbm8tdW51c2VkLXZhcnNcbiAgcmV0dXJuIHtcbiAgICBpY29uOiBcImJhblwiLFxuICAgIG1ldGhvZDogXCIhcmVmdW5kLWFuZC1leGNoYW5nZS5jb250ZW50LnJlZnVuZC5ub25lLm1ldGhvZFwiLFxuICAgIG1ldGhvZF9zaW1wbGlmaWVkOiBcIiFyZWZ1bmQtYW5kLWV4Y2hhbmdlLmNvbnRlbnQucmVmdW5kLm5vbmUubWV0aG9kLnNpbXBsaWZpZWRcIlxuICB9O1xufVxuXG5leHBvcnQgZGVmYXVsdCBub1JlZnVuZHM7XG4iXX0=